export default {
  name: 'de',
  messages: {
    _default: field => `Die Angabe für das Feld „${field}” ist ungültig.`,
    required: field => `Bitte machen Sie eine Angabe für „${field}”.`,
    confirmed: field => `Die Wiederholung des Feldes „${field}” stimmt nicht überein.`,
    min: (fieldName, params) => `${fieldName} muss mindestens ${params[0]} Zeichen lang sein.`
  }
}
